import {PageHeader} from './PageHeader'
import {PageItem} from './PageItem'
import {PageContainer} from './PageContainer'
import {PagePullout} from './PagePullout'
import {PageContent} from './PageContent'
import {PageTemplate} from './PageTemplate'
import {PageBlocksTemplate} from './PageBlocksTemplate'

const PageRoot = () => {
  return null
}

export const Page = Object.assign(PageRoot, {
  Container: PageContainer,
  Content: PageContent,
  Header: PageHeader,
  Item: PageItem,
  Pullout: PagePullout,
  Template: PageTemplate,
  BlocksTemplate: PageBlocksTemplate,
})
